angular.module("ainapp")
    .controller("ViewWarningLettersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "View Warning Letters";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.EmployeeId = $scope.TokenInfo.EmployeeId;
                        MainService.WarningLettersInGrid(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            RespondDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Subject: {
                                type: "string",
                                editable: false,
                            },

                            Remarks: {
                                type: "string",
                                editable: false,
                            },

                            Response: {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "Date",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Subject",
                        title: "Subject",
                        headerTemplate: "{{LanguageData.Reason}}",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        headerTemplate: "{{LanguageData.Remarks}}",
                        },
                    {
                        field: "RespondDate",
                        title: "RespondDate",
                        headerTemplate: "{{LanguageData.RespondDate}}",
                        template: "#= kendo.toString(kendo.parseDate(RespondDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Response",
                        title: "Response",
                        headerTemplate: "{{LanguageData.Response}}",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-save' ng-click='update(dataItem)'> </button>",
                        width: '80px'
                        },
                    ],
            };



            $scope.SelectedData = {};
            $scope.update = function (data) {
                $scope.SelectedData = angular.copy(data);
                $("#updateModal").modal("show");
            }

            $scope.SaveData = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateWarningLetter($scope.SelectedData).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        toastr.success($scope.LanguageData.Success);
                        $("#updateModal").modal("hide");
                    } else {
                        toastr.error($scope.LanguageData.Error);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }
                }]);
